import React from "react";
import {Card, CardActions} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import {exportacionesResources} from "../endpoints";
import Collapse from "@material-ui/core/Collapse";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

class CardExportar extends React.Component{
    constructor(props) {
        super(props);
        if (this.props.title === '1. Envía PDF' ||this.props.title === '2. Envía Financial'|| this.props.title === '3. Envía Itemfile'   ){
            this.state={
                open: false,
                progress: false,
                disabled: false,
                severity: null,
                message: null,
                backgroundColor: "#90caf9"
            }
        }
        else {
            this.state={
                open: false,
                progress: false,
                disabled: false,
                severity: null,
                message: null,
                backgroundColor: null

            }
        }

    }

    exportar = () => {
        this.setState({progress:true,disabled:true, open:false})
        const ruta = this.props.endpoint
        exportacionesResources.exportar(ruta).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then( result => {
            if(result.message){
                this.setState({
                    progress:false,
                    open: true,
                    message: result.message,
                    severity: result.severity,
                    disabled:false})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                progress:false,
                open: true,
                message:"Ha ocurrido un error inesperado",
                severity: "error",
                disabled:false})
        });
        setTimeout(() => {
            // After 6 seconds set the show value to false
            this.setState({open:false})
        }, 6000)
    }


    render() {
        return(
                <Card style={{display: 'inline-grid', backgroundColor: this.state.backgroundColor}}>
                    <Typography style={{margin:'16px'}} variant={'h5'}>{this.props.title}</Typography>
                    {this.state.progress ? <CircularProgress style={{display: 'inline-grid', justifySelf: 'center'}}/>: null}
                    <CardActions>
                        <Button disabled={this.state.disabled}  variant="contained" color={'primary'} onClick={this.exportar}>
                            Exportar
                        </Button>
                    </CardActions>
                    {this.state.open?
                        <Collapse in={this.state.open}>
                            <Alert
                                variant="filled"
                                severity={this.state.severity}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                            this.setState({open: false});
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                            >
                                {this.state.message}
                            </Alert>
                        </Collapse> : null}
                </Card>
        )
    }
}

export default CardExportar